import { motion } from "framer-motion";
import { gsap } from 'gsap';
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useGetAllCollectionQuery } from '../../redux/APIs/productApi';
import AnimatedCard from "./AnimatedCard";


const urls = [
  'https://www.taneira.com/on/demandware.static/-/Sites-Taneira-Library/default/dwcc3ab9f0/HomePage/KTV/Unit-9_Unit-8-1000x1500-px-7.jpg',
  'https://www.taneira.com/dw/image/v2/BKMH_PRD/on/demandware.static/-/Sites-Taneira-product-catalog/default/dw6d5505b9/images/Taneira/Catalog/SHG08C00413_1.jpg?sw=1000&sh=1500',
  'https://www.taneira.com/dw/image/v2/BKMH_PRD/on/demandware.static/-/Sites-Taneira-product-catalog/default/dw5ad8ce9f/images/Taneira/Catalog/SHG07L01155_1.jpg?sw=1000&sh=1500',
  'https://www.taneira.com/dw/image/v2/BKMH_PRD/on/demandware.static/-/Sites-Taneira-product-catalog/default/dwa08793d4/images/Taneira/Catalog/SHG07L01173_1.jpg?sw=1000&sh=1500'
];

const CollectionCards = () => {

  const {data: collections, isLoading} = useGetAllCollectionQuery();

  console.log('allCollections', collections);

  const navigate = useNavigate();

  useEffect(() => {
    const tl = gsap.timeline({ repeat: -1 });

    tl.fromTo(
      '.ripple-1',
      { scale: 1, opacity: 1 },
      { scale: 2, opacity: 0, duration: 2, ease: 'circ.out' }
    ).fromTo(
      '.ripple-2',
      { scale: 1, opacity: 1 },
      { scale: 2, opacity: 0, duration: 2, ease: 'circ.out' },
      '-=3.5'
    );

    return () => {
      tl.kill();
    };
  }, []);

  return (
    <div className="w-full">
      <div className="flex items-center w-full justify-center pt-28">
        <motion.div
          initial={{ x: 40, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 1 }}
          className="flex items-center"
        >
          <span className="w-3 h-3 rotate-45 bg-amber-600"></span>
          <span className="w-2 h-2 rounded-full ml-2 mr-5 rotate-45 bg-amber-600"></span>
          <span className="w-20 h-0.5 rounded-full bg-rose-700 mr-5"></span>
        </motion.div>
        <motion.span
          initial={{ scale: 0.7, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 2 }}
          className=" text-4xl text-rose-800 font-serif relative"
        >
          Spotlight Selections
          <div className="text-[2.2rem] text-amber-600 font-serif absolute top-0 right-0 opacity-20">
            Spotlight Selections
          </div>
        </motion.span>
        <motion.div
          initial={{ x: -40, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 1 }}
          className="flex items-center"
        >
          <span className="w-20 h-0.5 rounded-full bg-rose-700 ml-5"></span>
          <span className="w-2 h-2 rounded-full ml-5 mr-2 rotate-45 bg-amber-600"></span>
          <span className="w-3 h-3 rotate-45 bg-amber-600"></span>
        </motion.div>
      </div>
      <div className="flex px-2 py-5 pt-0 bg-gradient-to-b from-white to-rose-400 w-full min-h-96 gap-20 flex-wrap h-fit justify-center">
        <div className='flex gap-0 items-center w-full justify-center relative'>
        <div className="h-[400px] w-[200px] bg-gradient-to-b from-white to-transparent rotate-[30deg] -mt-12" style={{clipPath: 'polygon(40% 0%, 60% 0%, 100% 100%, 0% 100%)'}}></div>
        <div className="h-[400px] w-[200px] bg-gradient-to-b from-white to-transparent" style={{clipPath: 'polygon(40% 0%, 60% 0%, 100% 100%, 0% 100%)'}}></div>
        <div className="h-[400px] w-[200px] bg-gradient-to-b from-white to-transparent -rotate-[30deg] -mt-12" style={{clipPath: 'polygon(40% 0%, 60% 0%, 100% 100%, 0% 100%)'}}></div>

        <div className='flex items-center gap-20 absolute top-40'>
        <Link to='/products' 
       
     
      className="w-72 h-96 bg-blue-500 text-white rounded-xl shadow-lg transform transition-all duration-300 ease-out">
          <img
            src="https://www.taneira.com/on/demandware.static/-/Sites-Taneira-Library/default/dwcc3ab9f0/HomePage/KTV/Unit-9_Unit-8-1000x1500-px-7.jpg"
            className="w-full h-full object-cover rounded-br-[5rem] rounded-tl-[5rem]"
          />
        </Link>
        <Link to='/products' 
      
      className="w-72 h-96 bg-blue-500 text-white rounded-xl shadow-lg transform transition-all duration-300 ease-out">
          <img
            src="https://www.taneira.com/on/demandware.static/-/Sites-Taneira-Library/default/dwcc3ab9f0/HomePage/KTV/Unit-9_Unit-8-1000x1500-px-7.jpg"
            className="w-full h-full object-cover rounded-br-[5rem] rounded-tl-[5rem]"
          />
        </Link>
        <Link to='/products' 
      
      className="w-72 h-96 bg-blue-500 text-white rounded-xl shadow-lg transform transition-all duration-300 ease-out">
          <img
            src="https://www.taneira.com/on/demandware.static/-/Sites-Taneira-Library/default/dwcc3ab9f0/HomePage/KTV/Unit-9_Unit-8-1000x1500-px-7.jpg"
            className="w-full h-full object-cover rounded-br-[5rem] rounded-tl-[5rem]"
          />
        </Link>
        </div>
        </div>
        
        <div className="w-full flex justify-center mt-4">
          <div className="relative p-2 rounded-full bg-red-500 bg-opacity-40 overflow-hidden hover:scale-110 transition-all">
            <div className="absolute inset-0 p-2 rounded-full bg-red-300  ripple-1"></div>
            <div className="absolute inset-0 p-2 rounded-full bg-red-500  ripple-2"></div>
            <button  onClick={()=>navigate('/products')} className="relative px-4 py-2.5 rounded-full bg-red-600 text-white font-bodyPhilosopher font-semibold">
              Uncover More
            </button>
          </div>
          
        </div>
        <AnimatedCard/>
      </div>
    </div>
  );
}

export default CollectionCards